export const CLICK_OUTSIDE_IGNORE_ATTRIBUTE = 'data-c99-click-outside-ignore';
export const CLICK_OUTSIDE_IGNORE_SELECTOR = `[${CLICK_OUTSIDE_IGNORE_ATTRIBUTE}]`;

const didClickOnStickyPopover = (target: EventTarget | null) => {
  if (target instanceof Element) {
    return target.closest(CLICK_OUTSIDE_IGNORE_SELECTOR) !== null;
  }
  return false;
};

export default didClickOnStickyPopover;
